const abonos = state => state.abonos;
const tipoabono = state => state.tipoabono;
const series = state => state.series;

export default {
  abonos,
  tipoabono,
  series,
};